(function () {
    'use strict';

    angular.module("imApp").factory("stockBatchGetService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 293,
                    parameters: parms || {}
                });
            },
            getReportDefinition: function (edit) {
                return $ihttp.post({
                    method: 1624,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 474,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
